import { COMMON_OFFERS, ACTIONS, INSURANCE_OFFERS, BUSINESS_OFFERS, EDUCATION_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';

var _a$1;
var SPECIAL_OFFERS_LABELS = (_a$1 = {},
    _a$1[COMMON_OFFERS.savings] = 'Вклады',
    _a$1[COMMON_OFFERS.accumulative] = 'Накопительные счета',
    _a$1[COMMON_OFFERS.credits] = 'Кредиты',
    _a$1[COMMON_OFFERS.mortgage] = 'Ипотека',
    _a$1[COMMON_OFFERS.creditCards] = 'Кредитные карты',
    _a$1[COMMON_OFFERS.debitCards] = 'Дебетовые карты',
    _a$1[COMMON_OFFERS.loan] = 'Займы',
    _a$1[COMMON_OFFERS.brokerskoeObsluzhivanie] = 'Брокерское обслуживание',
    _a$1[COMMON_OFFERS.bankrotstvo] = 'Банкротство физических лиц',
    _a$1[ACTIONS.osago] = 'Осаго',
    _a$1[INSURANCE_OFFERS.insuranceOsago] = 'Страхование ОСАГО',
    _a$1[INSURANCE_OFFERS.dms] = 'ДМС',
    _a$1[INSURANCE_OFFERS['strahovanie-domov']] = 'Страхование домов',
    _a$1[INSURANCE_OFFERS['strahovka-kriticheskie-bolezni']] = 'Страхование от критических заболеваний',
    _a$1[INSURANCE_OFFERS['strahovka-ot-klescha']] = 'Страховка от укуса клеща',
    _a$1[BUSINESS_OFFERS.biznesRegistration] = 'Регистрация бизнеса',
    _a$1[BUSINESS_OFFERS.biznesRko] = 'РКО',
    _a$1[BUSINESS_OFFERS.biznesKredity] = 'Бизнес-кредиты',
    _a$1[BUSINESS_OFFERS.biznesEkvajring] = 'Эквайринг',
    _a$1[BUSINESS_OFFERS.biznesAccounting] = 'Бухгалтерия для бизнеса',
    _a$1[BUSINESS_OFFERS.bankovskieGarantii] = 'Банковские гарантии',
    // [BUSINESS_OFFERS.biznesDepozit]: 'Вклады для бизнеса',
    _a$1[BUSINESS_OFFERS.biznesMarketplace] = 'Бизнес на маркетплейсах',
    _a$1[BUSINESS_OFFERS.biznesLeasing] = 'Лизинг',
    _a$1[BUSINESS_OFFERS.zarplatnyjProekt] = 'Зарплатные проекты',
    _a$1[BUSINESS_OFFERS.biznesVed] = 'ВЭД',
    _a$1);
var LEARNING_TYPE_LABELS = {
    typeProgramming: 'Программирование',
    typeAnalytics: 'Аналитика',
    typeMarketing: 'Маркетинг',
    typeDesign: 'Дизайн',
    typeManagement: 'Бизнес и управление',
    typeAdmin: 'Администрирование',
    typeFinance: 'Финансы',
    typeLanguage: 'Иностранные языки',
    typeCreativity: 'Творчество и создание контента',
    typeSoftSkills: 'Саморазвитие и soft skills',
    typeApplication: 'Рукоделие',
    typeBeauty: 'Красота и здоровье',
    typePO: 'Прикладные программы',
    typeSport: 'Спорт',
    typeDPO: 'ДПО'
};

var _a;
var SPECIAL_TAB_TO_TITLE_MAP = (_a = {},
    _a[COMMON_OFFERS.savings] = 'по вкладам',
    _a[COMMON_OFFERS.credits] = 'по кредитам',
    _a[COMMON_OFFERS.debitCards] = 'по дебетовым картам',
    _a[COMMON_OFFERS.creditCards] = 'по кредитным картам',
    _a[COMMON_OFFERS.mortgage] = 'по ипотеке',
    _a[COMMON_OFFERS.loan] = 'по займам',
    _a[COMMON_OFFERS.accumulative] = 'по накопительным счетам',
    _a[COMMON_OFFERS.brokerskoeObsluzhivanie] = 'по брокерскому обслуживанию',
    _a[COMMON_OFFERS.bankrotstvo] = 'по банкротству физических лиц',
    _a[ACTIONS.osago] = 'по ОСАГО',
    _a[INSURANCE_OFFERS.insuranceOsago] = 'по страхованию ОСАГО',
    _a[INSURANCE_OFFERS.dms] = 'по добровольному медицинскому страхованию',
    _a[INSURANCE_OFFERS['strahovanie-domov']] = 'по страхованию дома и дачи',
    _a[INSURANCE_OFFERS['strahovka-kriticheskie-bolezni']] = 'по страхованию от критических заболеваний',
    _a[INSURANCE_OFFERS['strahovka-ot-klescha']] = 'по страховке от укуса клеща',
    _a[BUSINESS_OFFERS.biznesRegistration] = 'по регистрации бизнеса',
    _a[BUSINESS_OFFERS.biznesRko] = 'по РКО',
    _a[BUSINESS_OFFERS.biznesKredity] = 'по кредитам для бизнеса',
    _a[BUSINESS_OFFERS.biznesEkvajring] = 'по эквайрингу',
    _a[BUSINESS_OFFERS.biznesAccounting] = 'по ведению бухгалтерского учёта',
    _a[BUSINESS_OFFERS.bankovskieGarantii] = 'по банковским гарантиям',
    // [BUSINESS_OFFERS.biznesDepozit]: 'по вкладам для бизнеса',
    _a[BUSINESS_OFFERS.biznesMarketplace] = 'по бизнесу на маркетплейсах',
    _a[BUSINESS_OFFERS.biznesLeasing] = 'по лизингу',
    _a[BUSINESS_OFFERS.zarplatnyjProekt] = 'по зарплатным проектам',
    _a[BUSINESS_OFFERS.biznesVed] = 'по ВЭД',
    _a);
var LEARNING_TYPES_TITLES = {
    typeProgramming: 'по программированию',
    typeAnalytics: 'по аналитике',
    typeMarketing: 'по маркетингу',
    typeDesign: 'по дизайну',
    typeManagement: 'по бизнесу и управлению',
    typeAdmin: 'по администрированию',
    typeFinance: 'по финансам',
    typeLanguage: 'по иностранным языкам',
    typeCreativity: 'по творчеству и созданию контента',
    typeSoftSkills: 'по саморазвитию и soft skills',
    typeApplication: 'по рукоделию',
    typeBeauty: 'по красоте и здоровью',
    typePO: 'по прикладным программам',
    typeSport: 'по спорту',
    typeDPO: 'по ДПО'
};

var getTabTitleTo = function (_a) {
    var type = _a.type, subtype = _a.subtype;
    if (type === EDUCATION_OFFERS.learning && subtype) {
        return LEARNING_TYPES_TITLES[subtype];
    }
    return SPECIAL_TAB_TO_TITLE_MAP[type];
};
var getTabTitle = function (_a) {
    var type = _a.type, subtype = _a.subtype;
    if (type === EDUCATION_OFFERS.learning && subtype) {
        return LEARNING_TYPE_LABELS[subtype];
    }
    return SPECIAL_OFFERS_LABELS[type];
};

export { getTabTitleTo as a, getTabTitle as g };
//# sourceMappingURL=getTitle-6237901b.js.map
